export enum QuestionType {
  LongTextQuestion = "long_text",
  ShortTextQuestion = "short_text"
}
